export function randomInteger(a, b) {
    return a + Math.floor((b - a) * Math.random());
}
